<div class="card-voucher">
	<div *ngIf="stage === 1">
		<mat-icon svgIcon="bb-icons:voucher" style="width: 20px" matPrefix></mat-icon>
		<span (click)="stage = 2" class="inserir-voucher">Inserir voucher</span>
	</div>

	<div *ngIf="stage === 2">
		<mat-form-field appearance="outline">
			<mat-icon svgIcon="bb-icons:voucher" matPrefix></mat-icon>
			<mat-label>Código do voucher</mat-label>
			<input
				matInput
				type="text"
				[maxlength]="12"
				[(ngModel)]="code"
				(ngModelChange)="updateVoucher()"
				(input)="onInput($event)"
			/>
			<mat-hint *ngIf="showMessage" class="msg-voucher">{{ errorMessage }}</mat-hint>
		</mat-form-field>
		<button class="btn-voucher" (click)="validateVoucher()" [disabled]="buttonDisabled">OK</button>
	</div>

	<div *ngIf="stage === 3" class="card-voucher__border">
		<mat-icon svgIcon="bb-icons:voucher" matPrefix></mat-icon>
		<span class="codigo-voucher">{{ code }}</span>
		<ui-common-info-svg
			matTooltip="Os pontos serão creditados em até 30 dias úteis."
			matTooltipPosition="above"
			class="info-voucher"
			*ngIf="showInfo"
		></ui-common-info-svg>
		<p class="pontos-voucher">{{ points }} pontos <span style="color: #df0979">Livelo</span></p>
	</div>
</div>
